export default "__VITE_ASSET__CIb$T19n__"